module.exports = __webpack_public_path__ + "media/images/products/banners/background-5cede39eaa2eba84118306a50789bf46.png";